import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'cnxinfo';
export const route = 'cnxinfo/[[...token]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "cnxinfo" */
/* webpackPrefetch: true */
'../components/InfoPage')));